import React, {Fragment, useState} from 'react';
import { Menu } from '@headlessui/react'
import {Link, useNavigate} from "react-router-dom";

import {ArrowDown} from "../icons";
import {AccountSettingsModal, WarningModal} from "../modal";
import {IUser, ROUTES} from "../../types";
import { LS } from "../../utils";
import {useQuery} from "react-query";

const { clearLS } = LS;

const Dropdown = () => {
  const { data }:
    {
      data: IUser | undefined;
    } = useQuery(["userInfo"], { refetchOnWindowFocus: false });

  const navigate = useNavigate();
  const [isOpenWarningModal, setIsOpenWarningModal] = useState<boolean>(false);
  const [openSettingsModal, setOpenSettingsModal] = useState<boolean>(false);

  const handleCloseSettingsModal = () => setOpenSettingsModal(false);

  const handleCloseWarningModal = () => {
    setIsOpenWarningModal(false);
  };

  const onLogout = () => {
    clearLS()
    navigate(ROUTES.MAIN);
  }

  return (
    <Menu>
      <WarningModal
        open={isOpenWarningModal}
        onClose={onLogout}
        onCloseWarningModal={handleCloseWarningModal}
        title=''
        subtitle="Вы действительно хотите выйти?"
      />
      <AccountSettingsModal open={openSettingsModal} onClose={handleCloseSettingsModal} />
      <Menu.Button className="relative z-10"><ArrowDown /></Menu.Button>
      <Menu.Items className="rounded mt-[10px] w-[292px] z-20 border border-solid border-gray top-[100%] absolute right-[-16px] pt-4 bg-white">
        <Menu.Item as={Fragment}>
          {({ active }) => (
            <div className="pb-3 px-2 border-b border-b-solid border-gray">
              <p className="text-[24px] leading-[24px] font-medium text-mainBlack mb-1">Вы: {data?.fio}</p>
            </div>
          )}
        </Menu.Item>
        {/*<Menu.Item as={Fragment}>*/}
        {/*  {() => (*/}
        {/*    <div className="border-b border-b-solid border-gray cursor-pointer hover:bg-gray duration-150 ease-in">*/}
        {/*      <Link to={ROUTES.STATISTICS} className="text-[14px] leading-[16px] text-black block py-3 px-2">Статистика</Link>*/}
        {/*    </div>*/}
        {/*  )}*/}
        {/*</Menu.Item>*/}
        <Menu.Item as={Fragment}>
          {() => (
            <div
              className="py-3 px-2 border-b border-b-solid border-gray cursor-pointer hover:bg-gray duration-150 ease-in"
               onClick={() => setOpenSettingsModal(true)}
            >
              <span className="text-[14px] leading-[16px] text-black block">Настройки аккаунта</span>
            </div>
          )}
        </Menu.Item>
        <Menu.Item as={Fragment}>
          {() => (
            <div className="border-b border-b-solid border-gray cursor-pointer hover:bg-gray duration-150 ease-in">
              <a href="https://t.me/b2b_support_bot" className="py-3 px-2 text-[14px] leading-[16px] text-black block">Написать в тех.поддержку</a>
            </div>
          )}
        </Menu.Item>
        <Menu.Item as={Fragment}>
          {() => (
            <div
              className="cursor-pointer hover:bg-gray duration-150 ease-in"
              onClick={() => setIsOpenWarningModal(true)}
            >
              <span className="py-3 px-2 text-[14px] leading-[16px] text-red block">Выйти из аккаунта</span>
            </div>
          )}
        </Menu.Item>
      </Menu.Items>
    </Menu>
  )
};

export default Dropdown;
